<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div
    [config]="preloaderService.getLoadingConfig(loaderKey)"
    [suiIsLoading]="loaderKey"
    class="preloader-wrapper dialog-form dialog-max-height-xl"
>
    <div class="siklu-mat-dialog-title" matDialogTitle>
        <h4>{{ 'customer.home.createOrEditLabel' | translate }}</h4>
        <button matDialogClose windeClose>
            <sui-svg-icon icon="cross" />
        </button>
    </div>
    @if (customer) {
        <div class="siklu-mat-dialog-body" matDialogContent>
            <winde-alert-error></winde-alert-error>

            <div class="form-group">
                <span class="form-label">{{ 'customer.name' | translate }}</span>
                <sui-string-component [config]="customer.name"></sui-string-component>
            </div>

            @if (customer?.childCompanies?.length) {
                <div class="mb-2">
                    <span>Child Companies: </span>
                    <span class="child-companies-list">{{ getChildCompanyNames() }}</span>
                </div>
            } @else {
                <div class="form-group toggle-container">
                    <span class="form-label">{{ 'customer.sikluCompany' | translate }}</span>
                    <sui-toggle-component [config]="customer.sikluCompany"></sui-toggle-component>
                </div>
                @if (!customer.sikluCompany.value && parentCompanyField) {
                    <div class="form-group">
                        <span class="form-label">{{ 'customer.parentCompany' | translate }}</span>
                        <sui-select-component [config]="parentCompanyField"></sui-select-component>
                    </div>
                }
            }

            <div>
                <span class="form-label">{{ 'customer.sales' | translate }}</span>
                <winde-multiple-select [config]="customer.sales" [displayName]="'login'"></winde-multiple-select>
            </div>

            @if (locationControl) {
                <div class="row">
                    <div class="form-group col-6">
                        <span class="form-label">{{ 'customer.location' | translate }}</span>
                        <sui-select-component [config]="locationControl"></sui-select-component>
                    </div>
                </div>
            }

            <h6>Send emails to registered sales contact of the company, after:</h6>

            <div class="row">
                <div class="form-group col-6">
                    <span class="form-label">{{ 'customer.bomExportDaysTimeout' | translate }}</span>
                    <sui-number-component [config]="customer.bomExportDaysTimeout"></sui-number-component>
                    <small>[0..10] Weeks since last BOM summary has been exported.</small>
                </div>
                <div class="form-group col-6">
                    <span class="form-label">{{ 'customer.designBomDaysTimeout' | translate }}</span>
                    <sui-number-component [config]="customer.designBomDaysTimeout"></sui-number-component>
                    <small>[0..10] Weeks since 1st design iterations where run, and BOM not exported</small>
                </div>
            </div>
        </div>
    }

    <div class="siklu-mat-dialog-footer" matDialogActions>
        <button matDialogClose windeTransparent>
            <sui-svg-icon icon="cross" />
            {{ 'entity.action.cancel' | translate }}
        </button>
        <button (click)="save()" windeGreen>
            <sui-svg-icon icon="save" />
            {{ 'entity.action.save' | translate }}
        </button>
    </div>
</div>
